'use client'
import { cn } from "@/util/cn";

interface ContainerProps extends React.ComponentProps<"div"> {}

const Container = ({ children, className, ...props }: ContainerProps) => {
  return (
    <div {...props} className={cn("max-w-6xl mx-auto px-5", className)}>
      {children}
    </div>
  );
};

export default Container;